import type { HelpCategory } from './types';
import { categories } from '../../content/help';
import styles from './HelpCenter.module.css';

interface HelpCategoryNavProps {
  isPlatformUser: boolean;
  onCategorySelect: (category: HelpCategory) => void;
}

export function HelpCategoryNav({
  isPlatformUser,
  onCategorySelect,
}: HelpCategoryNavProps) {
  // Filter categories based on user type
  const availableCategories = categories.filter(cat => {
    if (cat.type === 'common') return true;
    if (isPlatformUser && cat.type === 'platform') return true;
    if (!isPlatformUser && cat.type === 'institution') return true;
    return false;
  });

  return (
    <div className={styles.categoryGrid}>
      {availableCategories.map(category => (
        <button
          key={category.id}
          className={styles.categoryCard}
          onClick={() => onCategorySelect(category.id)}
        >
          <div className={styles.categoryIcon}>{category.icon}</div>
          <div className={styles.categoryContent}>
            <span className={styles.categoryName}>{category.name}</span>
            <span className={styles.categoryDesc}>{category.description}</span>
          </div>
        </button>
      ))}
    </div>
  );
}
